import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'

import { RootState } from '_store';

const connector = connect(
  (state: RootState) => ({ loggedIn: (state.system.user !== null) })
);

type PrivateRouteProps = ConnectedProps<typeof connector> & {
  component: any;
  exact?: boolean;
  path?: string;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ loggedIn, component: Component, ...rest }) => (
  <Route {...rest} render={routeProps => (
    loggedIn
      ? <Component {...routeProps} />
      : <Redirect to={{ pathname: '/login', state: { from: routeProps.location } }} />
  )} />
)

export default connector(PrivateRoute)
